import {
  FetchOncologySubmissionDataParams,
  OncologySubmissionApiResponse,
} from "../../../api/bigQuery/oncologySubmissionOrders";
import { getBearerToken } from "../../../api/postCall/bearerToken";
import { API_ENDPOINTS } from "../../../enums/apiUrls";
import { OrganizationType } from "../../../enums/organizationTypes";
import { logDataToConsole, logError } from "../../../utils/customLogger";
import { AsteraOncologyExternalFilterPayload } from "../utils/asteraOncologyExternalFilterPayload";

/**
 * Fetches oncology submission data for the external Astera table.
 *
 * @input params - Filter, pagination, and sort payload for the table request
 * @return OncologySubmissionApiResponse: Paginated STP file rows from BigQuery
 */
export const fetchAsteraOncologyExternalData = async (
  params:
    | AsteraOncologyExternalFilterPayload
    | FetchOncologySubmissionDataParams,
): Promise<OncologySubmissionApiResponse> => {
  const body: Record<string, unknown> = {
    org_id: OrganizationType.ASTERA,
    filters: params.filters ?? {},
    page: params.page ?? 1,
    request_id: params.request_id,
    order_by: params.order_by,
  };

  if (params.page_size !== undefined) {
    body.page_size = params.page_size;
  }

  if ("case_sensitive" in params && params.case_sensitive !== undefined) {
    body.case_sensitive = params.case_sensitive;
  }

  try {
    const token = await getBearerToken();
    const response = await fetch(API_ENDPOINTS.GET_PHARMA_STP_FILE_DATA, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    logDataToConsole("fetchAsteraOncologyExternalData", result);
    return result;
  } catch (error) {
    logError(error as Error, "Error in fetchAsteraOncologyExternalData");
    throw error;
  }
};
